import { h, Host } from "@stencil/core";
import { getViewportWidth } from "../../utils/getViewportWidth";
import { debounce } from "../../utils/debounce";
export class ComparisonTable {
    constructor() {
        this.windowWidth = getViewportWidth();
        this.hasMinimumColWidth = false;
        this.dataTable = false;
    }
    host;
    // looks for elements until selector is reached (e.g. look for all tr until the next .cat class)
    nextUntil = (elem, selector) => {
        const siblings = [];
        elem = elem.nextElementSibling;
        while (elem) {
            if (elem.matches(selector)) {
                break;
            }
            siblings.push(elem);
            elem = elem.nextElementSibling;
        }
        return siblings;
    };
    connectedCallback() {
        window.addEventListener("resize", this.handleResize);
        if (this.dataTable) {
            this.setColSpan();
        }
        else {
            this.setHeaders();
            this.checkMinimumColWidth();
        }
    }
    setHeaders = () => {
        const tableRows = this.host.querySelectorAll("tr");
        tableRows.forEach((row) => {
            if (row.children.length === 1) {
                row.classList.add("cat");
            }
            else {
                row.classList.add("sub-cat");
            }
        });
    };
    setColSpan = () => {
        const categories = this.host.querySelectorAll(".cat > td");
        if (this.windowWidth > 550) {
            const subCat = this.host.querySelector(".sub-cat");
            if (!subCat) {
                return;
            }
            const colSpan = subCat.querySelectorAll("td").length;
            categories.forEach((category) => {
                category.setAttribute("colspan", colSpan.toString());
            });
        }
        else {
            categories.forEach((category) => {
                category.removeAttribute("colspan");
            });
        }
    };
    handleResize = debounce(() => {
        this.windowWidth = getViewportWidth();
        this.checkMinimumColWidth();
        if (this.dataTable) {
            this.setColSpan();
        }
    }, 200);
    checkMinimumColWidth = () => {
        if (this.dataTable) {
            this.hasMinimumColWidth = false;
            return;
        }
        const firstDataRow = this.host.querySelector("tr");
        if (!firstDataRow) {
            return;
        }
        const columnCount = firstDataRow.querySelectorAll("th:not(.first)").length;
        this.hasMinimumColWidth = this.host.getBoundingClientRect().width < columnCount * 250;
    };
    // @ts-expect-error Event Typing is not correct
    handleLinkClick(ev) {
        if (ev.target.hasAttribute("data-target")) {
            const target = ev.target.getAttribute("data-target");
            const targetElements = this.host.querySelectorAll(`[data-info="${target}"]`);
            if (ev.target.classList.contains("opened")) {
                ev.target.classList.remove("opened");
                targetElements.forEach((el) => {
                    el.classList.remove("opened");
                });
            }
            else {
                ev.target.classList.add("opened");
                targetElements.forEach((el) => {
                    el.classList.add("opened");
                });
            }
        }
    }
    insertIcons = () => {
        const categories = Array.from(this.host.querySelectorAll(".cat .first"));
        categories.forEach((el) => {
            const icon = document.createElement("ux-icon");
            icon.setAttribute("name", "chevron-right");
            el.appendChild(icon);
        });
    };
    insertDataTags = () => {
        const categories = Array.from(this.host.querySelectorAll(".cat"));
        categories.forEach((el, index) => {
            el.setAttribute("data-target", `cat-${index}`);
            const elementsBetween = this.nextUntil(el, ".cat");
            elementsBetween.forEach((element) => {
                element.setAttribute("data-info", `cat-${index}`);
            });
        });
    };
    componentDidLoad() {
        if (this.dataTable) {
            this.insertIcons();
            this.insertDataTags();
        }
    }
    disconnectedCallback() {
        window.removeEventListener("scroll", this.handleLinkClick);
        window.removeEventListener("resize", this.handleResize);
    }
    render() {
        const baseClass = "ux-comparison-table";
        return (h(Host, { key: '7fef1d7399a0a4ab159897987223523fc25ec437', class: {
                [baseClass]: true,
                [`${baseClass}--data`]: this.dataTable,
                [`${baseClass}--content`]: !this.dataTable,
                [`${baseClass}--fixed-column-width`]: this.hasMinimumColWidth
            } }, h("slot", { key: 'c6a176dc7efc92c65a913b6b4122e45a29fc59ae' })));
    }
    static get is() { return "ux-comparison-table"; }
    static get originalStyleUrls() {
        return {
            "$": ["comparison-table.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["comparison-table.css"]
        };
    }
    static get properties() {
        return {
            "dataTable": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Is the Table mainly fed by numeric data or by text content"
                },
                "attribute": "data-table",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get states() {
        return {
            "windowWidth": {},
            "hasMinimumColWidth": {}
        };
    }
    static get elementRef() { return "host"; }
    static get listeners() {
        return [{
                "name": "click",
                "method": "handleLinkClick",
                "target": "window",
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=comparison-table.js.map
